import makeStyles from "@mui/styles/makeStyles";
import { dp } from "./metrics";

export const useScreenReaderStyles = makeStyles({
  srOnly: {
    height: dp(1),
    left: dp(-10000),
    overflow: "hidden",
    position: "absolute",
    top: "auto",
    width: dp(1),
  },
});
